import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import DOMPurify from "dompurify";
import { fetchBlogs } from "../data/blogs";
import { withImageVersion } from "../contextApi/ImageVersionContext";
import "../styles/blogs.css";

const Blogs = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const blogs = await fetchBlogs();
        setData(blogs);
      } catch (err) {
        console.log("error from blogs:", err);
        setError("Failed to load blogs.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return (
      <main className="blogs-page">
        <div className="blogs-container">Loading...</div>
      </main>
    );
  }

  if (error) {
    return (
      <main className="blogs-page">
        <div className="blogs-container">{error}</div>
      </main>
    );
  }

  return (
    <main className="blogs-page">
      <div className="blogs-container">
        <h1 className="blogs-heading">Blogs</h1>
        <p className="blogs-subtitle">
          <h4>Engineered Insights for Industrial Performance</h4>
          Explore armature technology, power tool expertise, maintenance solutions, and industrial knowledge built around precision, durability, and professional performance.

        </p>

        <div className="blog-list">
          {data.map((blog) => (
            <article className="blog-card" key={blog.slug}>
              <button
                className="blog-image-button"
                type="button"
                onClick={() => navigate(`/blogs/${blog.slug}`)}
                aria-label={`Read ${blog.title}`}
              >
                <img className="blog-image" src={withImageVersion(blog.image)} alt={blog.title} />
              </button>

              <div className="blog-content">
                {blog.category && <div className="blog-category" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog.category) }} />}
                <h2 className="blog-title">
                  <Link className="blog-title-link" to={`/blogs/${blog.slug}`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog.title) }} />
                </h2>
                <p className="blog-excerpt" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog.excerpt) }} />

                <div className="blog-share-row" aria-label="Share links">
                  <a className="blog-share-button" href="https://www.facebook.com/pixelpowertools" aria-label="Facebook">
                    <FaFacebookF />
                  </a>
                  <a className="blog-share-button" href="https://x.com/Pixelpowertools" aria-label="Twitter">
                    <FaTwitter />
                  </a>
                  <a className="blog-share-button" href="https://www.linkedin.com/company/pixeltoolsofficial/?viewAsMember=true" aria-label="LinkedIn">
                    <FaLinkedinIn />
                  </a>
                </div>
              </div>

            </article>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Blogs;
